/*
 * Copyright 2022. NXGN Management, LLC. All Rights Reserved.
 */

import { Component, Input, OnInit } from "@angular/core";
import { FormGroup, Validators } from "@angular/forms";
import { Country, Merchant, ownershipTypes, States } from "../../../../models";
import { MerchantService } from "../../../../services";
import { MERCHANT_CONSTANTS } from "../../../../utils/data.rest.constants";

@Component({
  selector: "app-beneficial-owner-edit",
  templateUrl: "./beneficial-owner-edit.component.html"
})
export class BeneficialOwnerEditComponent implements OnInit {
  @Input("parentGroup") parentGroup!: FormGroup;
  @Input("merchant") merchant!: Merchant;
  @Input("indexType") indexType!: number;
  requiredFlag = false;
  ownershipTypes = ownershipTypes;
  states = States;
  countries = Country;
  maxDate = new Date();

  constructor(private merchantService: MerchantService) {}

  ngOnInit(): void {
    if (
      this.merchant.accountDetails.worldPayAccountDetails.ownershipType === this.ownershipTypes.LLC ||
      this.merchant.accountDetails.worldPayAccountDetails.ownershipType === this.ownershipTypes.Partnership ||
      this.merchant.accountDetails.worldPayAccountDetails.ownershipType === this.ownershipTypes.NonProfit ||
      this.merchant.accountDetails.worldPayAccountDetails.ownershipType === this.ownershipTypes.PrivateCorporation
    ) {
      this.isRequired(true);
    } else {
      this.isRequired(false);
    }
  }

  get ownerFormControls() {
    return this.parentGroup.controls;
  }

  isWorldPay(): boolean {
    return this.merchantService.isWorldPay(this.merchant);
  }

  isRequired(flag: boolean): void {
    if (flag) {
      this.parentGroup.get("ssn")?.addValidators([Validators.required]);
      this.parentGroup.get("ssn")?.updateValueAndValidity();
      this.parentGroup.get("dateOfBirth")?.addValidators([Validators.required]);
      this.parentGroup.get("dateOfBirth")?.updateValueAndValidity();
    } else {
      this.parentGroup.get("ssn")?.removeValidators([Validators.required]);
      this.parentGroup.get("ssn")?.updateValueAndValidity();
      this.parentGroup.get("dateOfBirth")?.removeValidators([Validators.required]);
      this.parentGroup.get("dateOfBirth")?.updateValueAndValidity();
    }
  }

  isMandate(): boolean {
    this.requiredFlag =
      (this.merchant.accountDetails.worldPayAccountDetails.ownershipType &&
        this.merchant.accountDetails.worldPayAccountDetails.ownershipType === MERCHANT_CONSTANTS.SoleProprietorship) ||
      (this.merchant.accountDetails.worldPayAccountDetails.ownershipType === MERCHANT_CONSTANTS.PrivateCorporation &&
        this.indexType === 0) ||
      (this.merchant.accountDetails.worldPayAccountDetails.ownershipType === MERCHANT_CONSTANTS.LLC &&
        this.indexType === 0) ||
      (this.merchant.accountDetails.worldPayAccountDetails.ownershipType === MERCHANT_CONSTANTS.Partnership &&
        this.indexType === 0) ||
      (this.merchant.accountDetails.worldPayAccountDetails.ownershipType === MERCHANT_CONSTANTS.NonProfit &&
        this.indexType === 0) ||
      (this.ownerFormControls.percentOwned.value && parseFloat(this.ownerFormControls.percentOwned.value) >= 25);
    this.isRequired(this.requiredFlag);
    return this.requiredFlag;
  }
}
